// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--La4r6","auto-prolong":"dd31006766--auto-prolong--b6Pqi","hint":"dd31006766--hint--_Qk8p"};